



































import { defineComponent } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  props: {
    specification: { type: Object, required: true }
  },
  data: () => ({
    maxMakemodelsToShow: 7,
    showInfinite: false
  }),
  computed: {
    makeModels() {
      return this.specification.value
    }
  },
  methods: {
    toggleShow() {
      this.showInfinite = !this.showInfinite
    }
  },
  i18n: defineComponentTranslations({
    till: {
      en: 'till',
      el: 'έως'
    }
  })
})
